// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__2rjUv","bookingInfo":"TimeRange_bookingInfo__3K7vo","dateSection":"TimeRange_dateSection__2RSY0","timeZone":"TimeRange_timeZone__3AOYy"};